
import { useTranslation } from "react-i18next";
import { CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export const LoginHeader = () => {
  const { t } = useTranslation(["auth"]);
  
  return (
    <CardHeader>
      <CardTitle>{t("loginToAccount", { ns: "auth" })}</CardTitle>
      <CardDescription>
        {t("enterCredentials", { ns: "auth", defaultValue: "Enter your credentials to access your account" })}
      </CardDescription>
    </CardHeader>
  );
};
